import angular from 'angular'
import treeSelectDirective from './treeSelectDirective'

export default angular
    .module('app.treeSelect', [])
    .directive('treeSelect', treeSelectDirective)
    .name



// WEBPACK FOOTER //
// ./src/components/treeSelect/index.js